import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import {
  setAuthUser,
  getUserFromStorage,
  removeUserFromStorage,
  updateUser,
} from 'utils/auth';
import useLogin from 'hooks/useLogin';
import useLogout from 'hooks/useLogout';

const AuthContext = React.createContext();

const AuthProvider = (props) => {
  const [loginUser, loginInfo] = useLogin();
  const [logoutCurrentUser] = useLogout();
  const [user, setUser] = useState(null);
  const history = useHistory();

  const saveUserData = React.useCallback(
    (data) => {
      const authUser = setAuthUser(data);
      setUser(authUser);
      if (authUser) {
        history.push('/admin/overview');
      }
    },
    [history]
  );

  const login = React.useCallback(
    (form) =>
      loginUser(form).then((response) => {
        saveUserData(response);
      }),
    [loginUser, saveUserData]
  );

  const logout = React.useCallback(
    (form) => {
      logoutCurrentUser(form);
      removeUserFromStorage();
      setUser(null);
      history.push('/');
    },
    [logoutCurrentUser, history]
  );

  const updateUserDetails = React.useCallback((data) => {
    const userData = updateUser(data);
    setUser(userData);
  }, []);

  useEffect(() => {
    const userData = getUserFromStorage();
    if (userData) setUser(userData);
  }, []);

  const userData = user || getUserFromStorage();

  return (
    <AuthContext.Provider
      value={{
        loginInfo,
        login,
        user: userData,
        saveUserData,
        updateUserDetails,
        logout,
      }}
      {...props}
    />
  );
};

const useAuth = () => React.useContext(AuthContext);

export { AuthProvider, useAuth };
